export const HevyCoachDefaultPlan: Plan = {
  maximum_clients: 0,
  id: 'hevy_coach_free',
  title: 'Free',
  renewal_period: 'lifetime',
  type: 'none',
};

type PlanType = 'none' | 'paid_paddle' | 'trial' | 'beta';

export interface Plan {
  title: string;
  maximum_clients: number;
  id: string;
  paddle_update_payment_url?: string;
  paddle_subscription_id?: number;
  renewal_period: 'monthly' | 'lifetime';
  renewal_price?: string;
  renewal_currency?: string;
  type: PlanType;
}
/** https://developer.paddle.com/reference/ZG9jOjI1MzU0MDI2-subscription-status-reference */
export type CoachPlanStatus =
  | 'active'
  | 'past_due'
  | 'paused'
  | 'will_pause' /** This is one we added that means the subscription will pause at the end of the current billing period */
  | 'deleted';

export interface CoachsPlan extends Plan {
  status: CoachPlanStatus;
  renewal_date?: string;
  /** Next bill data from Paddle */
  next_bill?: {
    amount: number;
    currency: string;
    date: string;
  };
  user_previously_started_trial: boolean;
}
export interface GetAvailableCoachPlansResponse {
  available_plans: Plan[];
}
export interface GetCoachPlanResponse {
  current_plan: CoachsPlan;
}
export interface CoachPayment {
  id: number;
  amount: number;
  currency: string;
  is_paid: number;
  is_one_off_charge: boolean;
  receipt_url: string;
  payout_date: string;
}
export interface GetCoachPaymentHistoryResponse {
  payments: CoachPayment[];
}
